module.exports = __webpack_public_path__ + "img/Arrow.e6e28734.jpg";